import { Stack } from '@optimus-web/core';
import { DefaultErrorBoundary } from '@mews-commander/ui';
import inject from './inject';
import ResendEmailFormCard from './ResendEmailFormCard';

export const MailingTabComponent = ({ scope, refetchGroup }: $TSFixMe) => (
    <DefaultErrorBoundary>
        <Stack spacing="200" vertical>
            {/* @ts-expect-error $TSFixMeError: Type '{ form: string; scope: any; refetchGroup: any; }' is not assignable to type 'IntrinsicAttributes & Omit<Omit<Dispa... */}
            <ResendEmailFormCard form={`resend-email-form-${scope}`} scope={scope} refetchGroup={refetchGroup} />
        </Stack>
    </DefaultErrorBoundary>
);

// @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
export const MailingTab = inject(MailingTabComponent);
